<template>
  <div>
    <Pos_supplier_edit/>
  </div>
</template>

<script>
import Pos_supplier_edit from "@/components/adminArin/pos_system/product/Pos_supplier_edit";
export default {
  name: "PosSupplierEdit",
  components: {
    Pos_supplier_edit
  }
}
</script>

<style scoped>

</style>
